import config from '../config';
import axios from 'axios';

// テスト用の広告データ
const TEST_ADVERTISEMENTS = [
  {
    id: 'test-ad-1',
    title: 'インフィードテスト\n\n掲載募集中',
    description: '',
    image: 'https://placehold.jp/600x400.png?text=テスト広告1',
    url: 'https://example.com',
    companyName: 'テスト企業',
    price: 1000
  },
  {
    id: 'test-ad-2',
    title: 'テスト広告2\n\nこれはテスト用の広告2です。\nバックエンドが実装されるまでの仮表示です。',
    description: '',
    image: 'https://placehold.jp/600x400.png?text=テスト広告2',
    url: 'https://example.com',
    companyName: 'テスト企業2',
    price: 800
  },
  {
    id: 'test-ad-3',
    title: 'テスト広告3',
    description: '地域限定の広告のテストです。',
    image: 'https://placehold.jp/600x400.png?text=テスト広告3',
    url: 'https://example.com',
    companyName: 'テスト企業3',
    price: 1200
  },
  {
    id: 'test-ad-4',
    title: 'テスト広告4',
    description: 'インフィード広告のテストです。',
    image: 'https://placehold.jp/600x400.png?text=テスト広告4',
    url: 'https://example.com',
    companyName: 'テスト企業4',
    price: 900
  },
  {
    id: 'test-ad-5',
    title: 'テスト広告5',
    description: '最後のテスト広告です。',
    image: 'https://placehold.jp/600x400.png?text=テスト広告5',
    url: 'https://example.com',
    companyName: 'テスト企業5',
    price: 1100
  }
];

/**
 * 広告データを取得するサービス
 */
const advertisementService = {
  /**
   * エリアトップ広告を取得する
   * @param {string} prefecture - 県名またはall（すべての都道府県）
   * @param {string} city - 市区町村コード
   * @returns {Promise<Array>} 広告データの配列（ファーストビューのため1件のみ）
   */
  getTopAdvertisements: async (prefecture, city) => {
    try {
      // パラメータの準備
      const params = { limit: 1 }; // 1件のみ取得
      
      // 都道府県コードを追加
      if (prefecture !== 'all') {
        params.prefecture = prefecture;
      }
      
      // 市区町村コードが指定されている場合は追加
      if (city) {
        params.city = city;
      }
      
      console.log('広告API呼び出し:', `${config.API_BASE_URL}/api/corporate/advertisements/top`, params);
      
      // 実際のAPIエンドポイントを使用
      const response = await axios.get(`${config.API_BASE_URL}/api/corporate/advertisements/top`, {
        params,
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
        timeout: 5000, // 5秒タイムアウト
        maxRedirects: 0, // リダイレクトを自動的に追従しない
      });
      
      console.log('広告APIレスポンス:', response.data);
      
      // 広告データを取得
      const advertisements = response.data.advertisements || [];
      
      // 広告が見つからなかった場合はテストデータを返す（開発モードのみ）
      if (advertisements.length === 0 && process.env.NODE_ENV === 'development') {
        console.log('広告が見つからないため、テストデータを使用します');
        return [TEST_ADVERTISEMENTS[0]];
      }
      
      return advertisements;
    } catch (error) {
      console.warn('広告取得エラー:', error.message);
      
      // リダイレクトエラーの場合
      if (error.message && error.message.includes('Redirect')) {
        console.warn('リダイレクトエラー検出: 代替データを使用します');
      }
      
      // タイムアウトエラーの場合
      if (error.code === 'ECONNABORTED') {
        console.warn('広告API呼び出しがタイムアウトしました: 代替データを使用します');
      }
      
      // 開発モードでは、APIエラー時にテストデータを返す
      if (process.env.NODE_ENV === 'development') {
        return [TEST_ADVERTISEMENTS[0]];
      }
      
      // 本番環境では空の配列を返す
      return [];
    }
  },
  
  /**
   * インフィード広告を取得する
   * @param {string} prefecture - 県名またはall（すべての都道府県）
   * @param {string} city - 市区町村コード
   * @param {number} count - 取得する広告の数
   * @returns {Promise<Array>} 広告データの配列
   */
  getFeedAdvertisements: async (prefecture, city, count = 5) => {
    try {
      // パラメータの準備
      const params = { count };
      
      // 都道府県コードを追加
      if (prefecture !== 'all') {
        params.prefecture = prefecture;
      }
      
      // 市区町村コードが指定されている場合は追加
      if (city) {
        params.city = city;
      }
      
      console.log('フィード広告API呼び出し:', `${config.API_BASE_URL}/api/corporate/advertisements/feed`, params);
      
      // 実際のAPIエンドポイントを使用
      const response = await axios.get(`${config.API_BASE_URL}/api/corporate/advertisements/feed`, {
        params,
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
        timeout: 5000, // 5秒タイムアウト
        maxRedirects: 0, // リダイレクトを自動的に追従しない
      });
      
      console.log('フィード広告APIレスポンス:', response.data);
      
      // 広告データを取得
      const advertisements = response.data.advertisements || [];
      
      // 広告が見つからなかった場合はテストデータを返す（開発モードのみ）
      if (advertisements.length === 0 && process.env.NODE_ENV === 'development') {
        console.log('フィード広告が見つからないため、テストデータを使用します');
        return TEST_ADVERTISEMENTS.slice(0, count);
      }
      
      return advertisements;
    } catch (error) {
      console.warn('フィード広告取得エラー:', error.message);
      
      // リダイレクトエラーの場合
      if (error.message && error.message.includes('Redirect')) {
        console.warn('リダイレクトエラー検出: 代替データを使用します');
      }
      
      // タイムアウトエラーの場合
      if (error.code === 'ECONNABORTED') {
        console.warn('広告API呼び出しがタイムアウトしました: 代替データを使用します');
      }
      
      // 開発モードでは、APIエラー時にテストデータを返す
      if (process.env.NODE_ENV === 'development') {
        return TEST_ADVERTISEMENTS.slice(0, count);
      }
      
      // 本番環境では空の配列を返す
      return [];
    }
  },
  
  /**
   * すべての企業ユーザーのインフィード広告を単価順に取得する
   * @param {number} count - 取得する広告の数
   * @returns {Promise<Array>} 広告データの配列
   */
  getAllFeedAdvertisementsByPrice: async (count = 5) => {
    try {
      // パラメータの準備
      const params = { 
        count,
        sort_by_price: true  // 単価順にソート
      };
      
      console.log('単価順広告API呼び出し:', `${config.API_BASE_URL}/api/corporate/advertisements/feed`, params);
      
      // APIエンドポイントを呼び出し
      const response = await axios.get(`${config.API_BASE_URL}/api/corporate/advertisements/feed`, {
        params,
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
        timeout: 5000, // 5秒タイムアウト
        maxRedirects: 0, // リダイレクトを自動的に追従しない
      });
      
      console.log('単価順広告APIレスポンス:', response.data);
      
      // 広告データを取得
      const advertisements = response.data.advertisements || [];
      
      // 広告が見つからなかった場合はテストデータを返す（開発モードのみ）
      if (advertisements.length === 0 && process.env.NODE_ENV === 'development') {
        console.log('単価順広告が見つからないため、テストデータを使用します');
        // テストデータに広告フラグを追加
        return TEST_ADVERTISEMENTS.slice(0, count).map(ad => ({
          ...ad,
          is_advertisement: true
        }));
      }
      
      // 広告フラグを追加
      return advertisements.map(ad => ({
        ...ad,
        is_advertisement: true
      }));
    } catch (error) {
      console.warn('単価順広告取得エラー:', error.message);
      
      // リダイレクトエラーの場合
      if (error.message && error.message.includes('Redirect')) {
        console.warn('リダイレクトエラー検出: 代替データを使用します');
      }
      
      // タイムアウトエラーの場合
      if (error.code === 'ECONNABORTED') {
        console.warn('単価順広告API呼び出しがタイムアウトしました: 代替データを使用します');
      }
      
      // 開発モードでは、APIエラー時にテストデータを返す
      if (process.env.NODE_ENV === 'development') {
        // テストデータに広告フラグを追加
        return TEST_ADVERTISEMENTS.slice(0, count).map(ad => ({
          ...ad,
          is_advertisement: true
        }));
      }
      
      // 本番環境では空の配列を返す
      return [];
    }
  },
  
  /**
   * 指定した都道府県のインフィード広告を単価順に取得する
   * @param {string} prefecture - 都道府県コード
   * @param {number} count - 取得する広告の数
   * @returns {Promise<Array>} 広告データの配列
   */
  getPrefectureFeedAdvertisementsByPrice: async (prefecture, count = 5) => {
    try {
      // パラメータの準備
      const params = { 
        count,
        prefecture,
        sort_by_price: true  // 単価順にソート
      };
      
      console.log('都道府県別単価順広告API呼び出し:', `${config.API_BASE_URL}/api/corporate/advertisements/feed`, params);
      
      // APIエンドポイントを呼び出し
      const response = await axios.get(`${config.API_BASE_URL}/api/corporate/advertisements/feed`, {
        params,
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
        timeout: 5000, // 5秒タイムアウト
        maxRedirects: 0, // リダイレクトを自動的に追従しない
      });
      
      console.log('都道府県別単価順広告APIレスポンス:', response.data);
      
      // 広告データを取得
      const advertisements = response.data.advertisements || [];
      
      // 広告が見つからなかった場合はテストデータを返す（開発モードのみ）
      if (advertisements.length === 0 && process.env.NODE_ENV === 'development') {
        console.log('都道府県別単価順広告が見つからないため、テストデータを使用します');
        return TEST_ADVERTISEMENTS.slice(0, count);
      }
      
      return advertisements;
    } catch (error) {
      console.warn('都道府県別単価順広告取得エラー:', error.message);
      
      // リダイレクトエラーの場合
      if (error.message && error.message.includes('Redirect')) {
        console.warn('リダイレクトエラー検出: 代替データを使用します');
      }
      
      // タイムアウトエラーの場合
      if (error.code === 'ECONNABORTED') {
        console.warn('都道府県別単価順広告API呼び出しがタイムアウトしました: 代替データを使用します');
      }
      
      // 開発モードでは、APIエラー時にテストデータを返す
      if (process.env.NODE_ENV === 'development') {
        return TEST_ADVERTISEMENTS.slice(0, count);
      }
      
      // 本番環境では空の配列を返す
      return [];
    }
  },
  
  /**
   * 広告のクリックを記録する
   * @param {string} adId - 広告ID
   * @param {string} userRole - ユーザーロール（viewer, corporate, poster, admin）
   * @param {string} action - アクション種別（click, share）
   * @returns {Promise<Object>} クリック記録の結果
   */
  recordAdClick: async (adId, userRole = 'viewer', action = 'click') => {
    try {
      // ログイン中のユーザーIDを取得（存在する場合）
      const userId = localStorage.getItem('userId');
      // ダブルスラッシュを防ぐためにURLを正規化
      const baseUrl = config.API_BASE_URL.replace(/\/+$/, ''); // 末尾のスラッシュを削除
      const url = `${baseUrl}/api/corporate/advertisements/${adId}/click`;
      
      const response = await axios.post(url, {
        userRole,
        action,
        userId // ユーザーIDを送信（ログインしていない場合はnull）
      }, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      });
      
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  
  /**
   * 広告のステータス（いいねとブックマーク状態）を取得する
   * @param {string} adId - 広告ID
   * @returns {Promise<Object>} 広告ステータス（liked, bookmarked, likeCount）
   */
  getAdStatus: async (adId) => {
    try {
      // ダブルスラッシュを防ぐためにURLを正規化
      const baseUrl = config.API_BASE_URL.replace(/\/+$/, ''); // 末尾のスラッシュを削除
      const url = `${baseUrl}/api/corporate/advertisements/${adId}/status`;
      
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      });
      
      return response.data;
    } catch (error) {
      // エラー時はデフォルト値を返す
      return {
        liked: false,
        bookmarked: false,
        likeCount: 0
      };
    }
  },
  
  /**
   * 広告のインプレッション（表示）を記録する
   * @param {string} adId - 広告ID
   * @returns {Promise<Object>} 処理結果
   */
  recordImpression: async (adId) => {
    try {
      // ダブルスラッシュを防ぐためにURLを正規化
      const baseUrl = config.API_BASE_URL.replace(/\/+$/, ''); // 末尾のスラッシュを削除
      const url = `${baseUrl}/api/corporate/advertisements/${adId}/impression`;
      
      // インプレッションを記録するAPIを呼び出し
      const response = await axios.post(url, {}, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      });
      
      return response.data;
    } catch (error) {
      // エラーは表示のみとして処理を続行（非クリティカルエラー）
      return {
        status: 'error',
        message: 'インプレッション記録に失敗しました'
      };
    }
  },
  
  /**
   * 広告にいいねする/いいねを取り消す
   * @param {string} adId - 広告ID
   * @param {boolean} isLiking - いいねする場合はtrue、取り消す場合はfalse
   * @returns {Promise<Object>} 処理結果
   */
  likeAd: async (adId, isLiking = true) => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        throw new Error('認証トークンが見つかりません。ログインしてください。');
      }

      const method = isLiking ? 'post' : 'delete';
      // ダブルスラッシュを防ぐためにURLを正規化
      const baseUrl = config.API_BASE_URL.replace(/\/+$/, ''); // 末尾のスラッシュを削除
      const url = `${baseUrl}/api/corporate/advertisements/${adId}/like`;
      
      const response = await axios({
        method,
        url,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('広告いいね処理エラー:', error);
      
      if (error.response?.status === 401) {
        throw new Error('認証に失敗しました。再ログインしてください。');
      } else if (error.response?.status === 404) {
        throw new Error('指定された広告が見つかりません。');
      } else if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      
      throw new Error('いいね処理中にエラーが発生しました。');
    }
  },
  
  /**
   * 広告をブックマークする/ブックマークを取り消す
   * @param {string} adId - 広告ID
   * @param {boolean} isBookmarking - ブックマークする場合はtrue、取り消す場合はfalse
   * @returns {Promise<Object>} 処理結果
   */
  bookmarkAd: async (adId, isBookmarking = true) => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        throw new Error('認証トークンが見つかりません。ログインしてください。');
      }

      const method = isBookmarking ? 'post' : 'delete';
      // ダブルスラッシュを防ぐためにURLを正規化
      const baseUrl = config.API_BASE_URL.replace(/\/+$/, ''); // 末尾のスラッシュを削除
      const url = `${baseUrl}/api/corporate/advertisements/${adId}/bookmark`;
      
      const response = await axios({
        method,
        url,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('広告ブックマーク処理エラー:', error);
      
      if (error.response?.status === 401) {
        throw new Error('認証に失敗しました。再ログインしてください。');
      } else if (error.response?.status === 404) {
        throw new Error('指定された広告が見つかりません。');
      } else if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      
      throw new Error('ブックマーク処理中にエラーが発生しました。');
    }
  },
  
  /**
   * 広告データの配列からランダムな広告を取得する
   * @param {Array} ads - 広告データの配列
   * @param {number} count - 取得する広告の数
   * @returns {Array} ランダムに選択された広告の配列
   */
  getRandomAds: (ads, count) => {
    if (!ads || ads.length === 0) return [];
    if (ads.length <= count) return ads;
    
    // 配列をシャッフル
    const shuffled = [...ads].sort(() => 0.5 - Math.random());
    
    // 指定した数だけ取得
    return shuffled.slice(0, count);
  }
};

export default advertisementService; 